/* eslint-disable max-lines */
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const BgWrapper = styled.svg`
  height: 100%;
`;

const SpeakerBg = ({ color }) => {
  return (
    <BgWrapper
      width="171"
      viewBox="0 0 171 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g clipPath="url(#clip0)">
          <rect
            x="163.446"
            y="18.4424"
            width="3.07367"
            height="18.442"
            transform="rotate(-180 163.446 18.4424)"
            fill={color}
          />
          <rect
            x="165.023"
            y="42.752"
            width="3.07367"
            height="18.442"
            transform="rotate(170 165.023 42.752)"
            fill={color}
          />
          <rect
            x="166.507"
            y="66.792"
            width="3.07367"
            height="18.442"
            transform="rotate(160 166.507 66.792)"
            fill={color}
          />
          <rect
            x="167.85"
            y="90.46"
            width="3.07367"
            height="18.442"
            transform="rotate(150 167.85 90.46)"
            fill={color}
          />
          <rect
            x="169.013"
            y="113.908"
            width="3.07367"
            height="18.442"
            transform="rotate(140 169.013 113.908)"
            fill={color}
          />
          <rect
            x="169.96"
            y="137.171"
            width="3.07367"
            height="18.442"
            transform="rotate(130 169.96 137.171)"
            fill={color}
          />
          <rect
            x="170.663"
            y="160.291"
            width="3.07367"
            height="18.442"
            transform="rotate(120 170.663 160.291)"
            fill={color}
          />
          <rect
            x="171.1"
            y="183.308"
            width="3.07367"
            height="18.442"
            transform="rotate(110 171.1 183.308)"
            fill={color}
          />
          <rect
            x="171.256"
            y="206.276"
            width="3.07367"
            height="18.442"
            transform="rotate(100 171.256 206.276)"
            fill={color}
          />
          <rect
            x="171.13"
            y="229.242"
            width="3.07367"
            height="18.442"
            transform="rotate(90 171.13 229.242)"
            fill={color}
          />
        </g>
        <g clipPath="url(#clip1)">
          <rect
            x="134.507"
            y="18.1621"
            width="3.07367"
            height="18.442"
            transform="rotate(170 134.507 18.1621)"
            fill={color}
          />
          <rect
            x="135.99"
            y="42.2021"
            width="3.07367"
            height="18.442"
            transform="rotate(160 135.99 42.2021)"
            fill={color}
          />
          <rect
            x="137.334"
            y="65.8691"
            width="3.07367"
            height="18.442"
            transform="rotate(150 137.334 65.8691)"
            fill={color}
          />
          <rect
            x="138.497"
            y="89.3184"
            width="3.07367"
            height="18.442"
            transform="rotate(140 138.497 89.3184)"
            fill={color}
          />
          <rect
            x="139.443"
            y="112.581"
            width="3.07367"
            height="18.442"
            transform="rotate(130 139.443 112.581)"
            fill={color}
          />
          <rect
            x="140.146"
            y="135.701"
            width="3.07367"
            height="18.442"
            transform="rotate(120 140.146 135.701)"
            fill={color}
          />
          <rect
            x="140.583"
            y="158.721"
            width="3.07367"
            height="18.442"
            transform="rotate(110 140.583 158.721)"
            fill={color}
          />
          <rect
            x="140.739"
            y="181.687"
            width="3.07367"
            height="18.442"
            transform="rotate(100 140.739 181.687)"
            fill={color}
          />
          <rect
            x="140.613"
            y="204.653"
            width="3.07367"
            height="18.442"
            transform="rotate(90 140.613 204.653)"
            fill={color}
          />
          <rect
            x="132.929"
            y="240"
            width="3.07367"
            height="18.442"
            transform="rotate(-180 132.929 240)"
            fill={color}
          />
        </g>
        <g clipPath="url(#clip2)">
          <rect
            x="105.474"
            y="17.3594"
            width="3.07367"
            height="18.442"
            transform="rotate(160 105.474 17.3594)"
            fill={color}
          />
          <rect
            x="106.817"
            y="41.0273"
            width="3.07367"
            height="18.442"
            transform="rotate(150 106.817 41.0273)"
            fill={color}
          />
          <rect
            x="107.98"
            y="64.4756"
            width="3.07367"
            height="18.442"
            transform="rotate(140 107.98 64.4756)"
            fill={color}
          />
          <rect
            x="108.928"
            y="87.7373"
            width="3.07367"
            height="18.442"
            transform="rotate(130 108.928 87.7373)"
            fill={color}
          />
          <rect
            x="109.63"
            y="110.858"
            width="3.07367"
            height="18.442"
            transform="rotate(120 109.63 110.858)"
            fill={color}
          />
          <rect
            x="110.066"
            y="133.877"
            width="3.07367"
            height="18.442"
            transform="rotate(110 110.066 133.877)"
            fill={color}
          />
          <rect
            x="110.224"
            y="156.844"
            width="3.07367"
            height="18.442"
            transform="rotate(100 110.224 156.844)"
            fill={color}
          />
          <rect
            x="110.097"
            y="179.81"
            width="3.07367"
            height="18.442"
            transform="rotate(90 110.097 179.81)"
            fill={color}
          />
          <rect
            x="102.413"
            y="215.157"
            width="3.07367"
            height="18.442"
            transform="rotate(-180 102.413 215.157)"
            fill={color}
          />
          <rect
            x="103.99"
            y="239.467"
            width="3.07367"
            height="18.442"
            transform="rotate(170 103.99 239.467)"
            fill={color}
          />
        </g>
        <g clipPath="url(#clip3)">
          <rect
            x="76.2998"
            y="16.4385"
            width="3.07367"
            height="18.442"
            transform="rotate(150 76.2998 16.4385)"
            fill={color}
          />
          <rect
            x="77.4639"
            y="39.8857"
            width="3.07367"
            height="18.442"
            transform="rotate(140 77.4639 39.8857)"
            fill={color}
          />
          <rect
            x="78.4102"
            y="63.1484"
            width="3.07367"
            height="18.442"
            transform="rotate(130 78.4102 63.1484)"
            fill={color}
          />
          <rect
            x="79.1133"
            y="86.2686"
            width="3.07367"
            height="18.442"
            transform="rotate(120 79.1133 86.2686)"
            fill={color}
          />
          <rect
            x="79.5498"
            y="109.288"
            width="3.07367"
            height="18.442"
            transform="rotate(110 79.5498 109.288)"
            fill={color}
          />
          <rect
            x="79.7061"
            y="132.254"
            width="3.07367"
            height="18.442"
            transform="rotate(100 79.7061 132.254)"
            fill={color}
          />
          <rect
            x="79.5801"
            y="155.221"
            width="3.07367"
            height="18.442"
            transform="rotate(90 79.5801 155.221)"
            fill={color}
          />
          <rect
            x="71.8955"
            y="190.567"
            width="3.07367"
            height="18.442"
            transform="rotate(-180 71.8955 190.567)"
            fill={color}
          />
          <rect
            x="73.4736"
            y="214.877"
            width="3.07367"
            height="18.442"
            transform="rotate(170 73.4736 214.877)"
            fill={color}
          />
          <rect
            x="74.957"
            y="238.918"
            width="3.07367"
            height="18.442"
            transform="rotate(160 74.957 238.918)"
            fill={color}
          />
        </g>
        <g clipPath="url(#clip4)">
          <rect
            x="46.9473"
            y="15.2969"
            width="3.07367"
            height="18.442"
            transform="rotate(140 46.9473 15.2969)"
            fill={color}
          />
          <rect
            x="47.8936"
            y="38.5586"
            width="3.07367"
            height="18.442"
            transform="rotate(130 47.8936 38.5586)"
            fill={color}
          />
          <rect
            x="48.5967"
            y="61.6797"
            width="3.07367"
            height="18.442"
            transform="rotate(120 48.5967 61.6797)"
            fill={color}
          />
          <rect
            x="49.0332"
            y="84.6963"
            width="3.07367"
            height="18.442"
            transform="rotate(110 49.0332 84.6963)"
            fill={color}
          />
          <rect
            x="49.1895"
            y="107.665"
            width="3.07367"
            height="18.442"
            transform="rotate(100 49.1895 107.665)"
            fill={color}
          />
          <rect
            x="49.0635"
            y="130.631"
            width="3.07367"
            height="18.442"
            transform="rotate(90 49.0635 130.631)"
            fill={color}
          />
          <rect
            x="41.3799"
            y="165.979"
            width="3.07367"
            height="18.442"
            transform="rotate(-180 41.3799 165.979)"
            fill={color}
          />
          <rect
            x="42.957"
            y="190.288"
            width="3.07367"
            height="18.442"
            transform="rotate(170 42.957 190.288)"
            fill={color}
          />
          <rect
            x="44.4404"
            y="214.328"
            width="3.07367"
            height="18.442"
            transform="rotate(160 44.4404 214.328)"
            fill={color}
          />
          <rect
            x="45.7842"
            y="237.996"
            width="3.07367"
            height="18.442"
            transform="rotate(150 45.7842 237.996)"
            fill={color}
          />
        </g>
        <g clipPath="url(#clip5)">
          <rect
            x="17.376"
            y="13.9697"
            width="3.07367"
            height="18.442"
            transform="rotate(130 17.376 13.9697)"
            fill={color}
          />
          <rect
            x="18.0791"
            y="37.0898"
            width="3.07367"
            height="18.442"
            transform="rotate(120 18.0791 37.0898)"
            fill={color}
          />
          <rect
            x="18.5156"
            y="60.1094"
            width="3.07367"
            height="18.442"
            transform="rotate(110 18.5156 60.1094)"
            fill={color}
          />
          <rect
            x="18.6719"
            y="83.0752"
            width="3.07367"
            height="18.442"
            transform="rotate(100 18.6719 83.0752)"
            fill={color}
          />
          <rect
            x="18.5449"
            y="106.042"
            width="3.07367"
            height="18.442"
            transform="rotate(90 18.5449 106.042)"
            fill={color}
          />
          <rect
            x="10.8613"
            y="141.389"
            width="3.07367"
            height="18.442"
            transform="rotate(-180 10.8613 141.389)"
            fill={color}
          />
          <rect
            x="12.4395"
            y="165.698"
            width="3.07367"
            height="18.442"
            transform="rotate(170 12.4395 165.698)"
            fill={color}
          />
          <rect
            x="13.9229"
            y="189.739"
            width="3.07367"
            height="18.442"
            transform="rotate(160 13.9229 189.739)"
            fill={color}
          />
          <rect
            x="15.2656"
            y="213.407"
            width="3.07367"
            height="18.442"
            transform="rotate(150 15.2656 213.407)"
            fill={color}
          />
          <rect
            x="16.4287"
            y="236.854"
            width="3.07367"
            height="18.442"
            transform="rotate(140 16.4287 236.854)"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="240"
            height="18.6497"
            fill="white"
            transform="translate(171.233) rotate(90)"
          />
        </clipPath>
        <clipPath id="clip1">
          <rect
            width="240"
            height="18.6497"
            fill="white"
            transform="translate(140.717) rotate(90)"
          />
        </clipPath>
        <clipPath id="clip2">
          <rect
            width="240"
            height="18.6497"
            fill="white"
            transform="translate(110.2) rotate(90)"
          />
        </clipPath>
        <clipPath id="clip3">
          <rect
            width="240"
            height="18.6497"
            fill="white"
            transform="translate(79.6836) rotate(90)"
          />
        </clipPath>
        <clipPath id="clip4">
          <rect
            width="240"
            height="18.6497"
            fill="white"
            transform="translate(49.167) rotate(90)"
          />
        </clipPath>
        <clipPath id="clip5">
          <rect
            width="240"
            height="18.6497"
            fill="white"
            transform="translate(18.6494) rotate(90)"
          />
        </clipPath>
      </defs>
    </BgWrapper>
  );
};

SpeakerBg.propTypes = {
  color: PropTypes.string.isRequired
};

export default SpeakerBg;
